@let selectedAccount = selectedAccount$ | async;
@let depositBonusAvailability = depositBonusAvailability$ | async;
@let depositBonusExpirationDate = depositBonusExpirationDate$ | async;
@let bonusTimeLeft = bonusTimeLeft$ | async;
@let daysLeft = daysLeft$ | async;
@let arePromosLoading = arePromosLoading$ | async;

<global-breadcrumbs class="title--reset-margin-bottom-all" />

<global-bloomreach-banner-container [id]="'promotions'" />

@if (!selectedAccount?.isDemo) {
  @if (depositBonusAvailability?.bonusIsAvailable || depositBonusAvailability?.wasReceived) {
    <div class="promotions__title-row">
      <p class="promotions__title" translate="deposit-bonus.bonus"></p>
    </div>

    <global-deposit-bonus-panel
      [account]="selectedAccount"
      [bonusTimeLeft]="bonusTimeLeft"
      [daysLeft]="daysLeft"
      [depositBonusExpirationDate]="depositBonusExpirationDate"
      [link]="depositBonusAvailability.fullTerms"
      [wasReceived]="depositBonusAvailability.wasReceived"
    />
  }
}

@if (!arePromosLoading && selectedAccount) {
  <ul class="promotions__content-list">
    @if (bonuses$ | async; as bonuses) {
      @if (bonuses?.length) {
        <li class="promotions__item">
          <div class="promotions__title-row">
            <p class="promotions__title" translate="promo.title.bonuses"></p>
          </div>
          <ul class="promotions__card-list">
            @for (bonus of bonuses; track bonus) {
              <li
                class="promotions__card"
                [routerLink]="routes[bonus.name] || bonus.name"
                >
                <ng-container
                  *ngTemplateOutlet="promoItem; context: { promo: bonus }"
                  />
              </li>
            }
          </ul>
        </li>
      }
    }
    @if (contests$ | async; as contests) {
      @if (contests?.length) {
        <li class="promotions__item">
          <div class="promotions__title-row">
            <p class="promotions__title" translate="promo.title.contests"></p>
          </div>
          <ul class="promotions__card-list">
            @for (contest of contests; track contest) {
              <li
                class="promotions__card"
                [routerLink]="routes[contest.name] || contest.name"
                >
                <ng-container
                  *ngTemplateOutlet="promoItem; context: { promo: contest }"
                  />
              </li>
            }
          </ul>
        </li>
      }
    }
    @if (services$ | async; as services) {
      @if (services?.length) {
        <li class="promotions__item">
          <div class="promotions__title-row">
            <p class="promotions__title" translate="promo.title.services"></p>
          </div>
          <ul class="promotions__card-list">
            @for (service of services; track service) {
              <li
                class="promotions__card"
                [routerLink]="routes[service.name]"
                >
                <ng-container
                  *ngTemplateOutlet="promoItem; context: { promo: service }"
                  />
              </li>
            }
          </ul>
        </li>
      }
    }
  </ul>
} @else {
  <ng-container *ngTemplateOutlet="loader" />
}

<ng-template #promoItem let-promo="promo">
  @if (promo.promoImagesURL?.webURL) {
    <img
      class="promotions__card-image"
      src="{{ promo.promoImagesURL.webURL }}"
      />
  } @else {
    <div
      [class]="'promotions__card-image promotions__card-image--' + promo.name"
    ></div>
  }
  <div class="promotions__card-content">
    <h5 class="promotions__card-title">{{ promo.title | translate }}</h5>
    <p class="promotions__card-text">{{ promo.description | translate }}</p>
  </div>

</ng-template>

<ng-template #loader>
  <app-loader [isInner]="true" />
</ng-template>
